// This file is auto-generated by @hey-api/openapi-ts
import type { CancelablePromise } from "./core/CancelablePromise";
import { OpenAPI } from "./core/OpenAPI";
import { request as __request } from "./core/request";
import type {
  GetCustomApiConfigurationPublicHelloWorldResponse,
  GetCustomApiConfigurationPublicShoppingCartByQuoteIdExtendedDataData,
  GetCustomApiConfigurationPublicShoppingCartByQuoteIdExtendedDataResponse,
  GetCustomApiConfigurationPublicShoppingCartLineItemByLineItemIdExtendedDataData,
  GetCustomApiConfigurationPublicShoppingCartLineItemByLineItemIdExtendedDataResponse,
  GetCustomApiConfigurationPublicShoppingCartPositionsCountData,
  GetCustomApiConfigurationPublicShoppingCartPositionsCountResponse,
  PostCustomApiConfigurationPublicShoppingCartByQuoteIdExcelData,
  PostCustomApiConfigurationPublicShoppingCartByQuoteIdExcelResponse,
  PostCustomApiConfigurationPublicShoppingCartConfigurationsData,
  PostCustomApiConfigurationPublicShoppingCartConfigurationsEditData,
  PostCustomApiConfigurationPublicShoppingCartConfigurationsEditResponse,
  PostCustomApiConfigurationPublicShoppingCartConfigurationsResponse,
  PostCustomApiConfigurationPublicShoppingCartProductsData,
  PostCustomApiConfigurationPublicShoppingCartProductsResponse,
  PostCustomApiConfigurationPublicShoppingCartQuoteRequestMailData,
  PostCustomApiConfigurationPublicShoppingCartQuoteRequestMailResponse,
  PostCustomApiConfigurationPublicShoppingCartShowData,
  PostCustomApiConfigurationPublicShoppingCartShowResponse,
  PostCustomApiConfigurationPublicStartConfiguratorCfgKonfigStandardData,
  PostCustomApiConfigurationPublicStartConfiguratorCfgKonfigStandardResponse,
  PostCustomApiConfigurationPublicStartConfiguratorCfgProfiKonfiguratorData,
  PostCustomApiConfigurationPublicStartConfiguratorCfgProfiKonfiguratorResponse,
  PostCustomApiConfigurationPublicStartConfiguratorCfgProfiKonfiguratorSchnellData,
  PostCustomApiConfigurationPublicStartConfiguratorCfgProfiKonfiguratorSchnellResponse,
  PostCustomApiConfigurationPublicStartConfiguratorData,
  PostCustomApiConfigurationPublicStartConfiguratorResponse,
  PutCustomApiConfigurationPublicShoppingCartByQuoteIdExtendedDataData,
  PutCustomApiConfigurationPublicShoppingCartByQuoteIdExtendedDataResponse,
  PutCustomApiConfigurationPublicShoppingCartConfigurationsByLineItemIdData,
  PutCustomApiConfigurationPublicShoppingCartConfigurationsByLineItemIdResponse,
  PutCustomApiConfigurationPublicShoppingCartLineItemByLineItemIdExtendedDataData,
  PutCustomApiConfigurationPublicShoppingCartLineItemByLineItemIdExtendedDataResponse,
} from "./types.gen";

export class ConfigurationService {
  /**
   * Start configuration session for arbitrary CFG objects
   *     {
   * "localeID": "de-DE",
   * "userToken": "",
   * "userSessionID": "exampleSessionID",
   * "cfgObjectID": "CFG_KONFIG_STANDARD",
   * "externalId": "exampleID",
   * "callbackUrl": "exampleURL",
   * "geolocationId": "DE"
   * }
   * @param data The data for the request.
   * @param data.requestBody
   * @returns RedirectResponse OK
   * @throws ApiError
   */
  public static postCustomApiConfigurationPublicStartConfigurator(
    data: PostCustomApiConfigurationPublicStartConfiguratorData = {},
  ): CancelablePromise<PostCustomApiConfigurationPublicStartConfiguratorResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/custom/api/Configuration/public/startConfigurator",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        400: "Bad Request",
        500: "Internal Server Error",
      },
    });
  }

  /**
   * Start configuration session for a STANDARD_CFG Konfiguration
   * (parameters tailored for the STANDARD_CFG case)
   *     {
   * "localeID": "de-DE",
   * "userToken": "",
   * "userSessionID": "exampleSessionID",
   * "externalId": "exampleID",
   * "geolocationId": "DE"
   * }
   * @param data The data for the request.
   * @param data.requestBody
   * @returns RedirectResponse OK
   * @throws ApiError
   */
  public static postCustomApiConfigurationPublicStartConfiguratorCfgKonfigStandard(
    data: PostCustomApiConfigurationPublicStartConfiguratorCfgKonfigStandardData = {},
  ): CancelablePromise<PostCustomApiConfigurationPublicStartConfiguratorCfgKonfigStandardResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/custom/api/Configuration/public/startConfigurator/CFG_KONFIG_STANDARD",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        400: "Bad Request",
        500: "Internal Server Error",
      },
    });
  }

  /**
   * Start configuration session for a CFG_PROFI_CONFIGRATION Konfiguration (ie. SDT / SRT)
   *     {
   * "localeID": "de-DE",
   * "userToken": "",
   * "userSessionID": "exampleSessionID",
   * "productSegment": "SRT",
   * "geolocationId": "DE"
   * }
   * @param data The data for the request.
   * @param data.requestBody
   * @returns RedirectResponse OK
   * @throws ApiError
   */
  public static postCustomApiConfigurationPublicStartConfiguratorCfgProfiKonfigurator(
    data: PostCustomApiConfigurationPublicStartConfiguratorCfgProfiKonfiguratorData = {},
  ): CancelablePromise<PostCustomApiConfigurationPublicStartConfiguratorCfgProfiKonfiguratorResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/custom/api/Configuration/public/startConfigurator/CFG_PROFI_KONFIGURATOR",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        400: "Bad Request",
        500: "Internal Server Error",
      },
    });
  }

  /**
   * Start configuration session for a CFG_PROFI_CONFIGRATION SCNELL Konfiguration (ie. SDT / SRT)
   *     {
   * "localeID": "de-DE",
   * "userToken": "",
   * "userSessionID": "exampleSessionID",
   * "productSegment": "SRT",
   * "geolocationId": "DE"
   * }
   * @param data The data for the request.
   * @param data.requestBody
   * @returns RedirectResponse OK
   * @throws ApiError
   */
  public static postCustomApiConfigurationPublicStartConfiguratorCfgProfiKonfiguratorSchnell(
    data: PostCustomApiConfigurationPublicStartConfiguratorCfgProfiKonfiguratorSchnellData = {},
  ): CancelablePromise<PostCustomApiConfigurationPublicStartConfiguratorCfgProfiKonfiguratorSchnellResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/custom/api/Configuration/public/startConfigurator/CFG_PROFI_KONFIGURATOR_SCHNELL",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        400: "Bad Request",
        500: "Internal Server Error",
      },
    });
  }

  /**
   * Adds the configuration session ID to the user's shopping cart using their session ID.
   * @param data The data for the request.
   * @param data.requestBody The line item body containing the product details.
   * @returns QuoteResponse OK
   * @throws ApiError
   */
  public static postCustomApiConfigurationPublicShoppingCartConfigurations(
    data: PostCustomApiConfigurationPublicShoppingCartConfigurationsData = {},
  ): CancelablePromise<PostCustomApiConfigurationPublicShoppingCartConfigurationsResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/custom/api/Configuration/public/shoppingCart/configurations",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        500: "Internal Server Error",
      },
    });
  }

  /**
   * Edits a configuration that was previously added to the shopping cart.
   * @param data The data for the request.
   * @param data.requestBody The line item body containing the product details.
   * @returns RedirectResponse OK
   * @throws ApiError
   */
  public static postCustomApiConfigurationPublicShoppingCartConfigurationsEdit(
    data: PostCustomApiConfigurationPublicShoppingCartConfigurationsEditData = {},
  ): CancelablePromise<PostCustomApiConfigurationPublicShoppingCartConfigurationsEditResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/custom/api/Configuration/public/shoppingCart/configurations/edit",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        500: "Internal Server Error",
      },
    });
  }

  /**
   * Returns URL to show the current Shoppingcart for the userSessionId.
   * @param data The data for the request.
   * @param data.requestBody
   * @returns RedirectResponse OK
   * @throws ApiError
   */
  public static postCustomApiConfigurationPublicShoppingCartShow(
    data: PostCustomApiConfigurationPublicShoppingCartShowData = {},
  ): CancelablePromise<PostCustomApiConfigurationPublicShoppingCartShowResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/custom/api/Configuration/public/shoppingCart/show",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        500: "Internal Server Error",
      },
    });
  }

  /**
   * Returns the number of positions in a quote for a given user session ID.
   * @param data The data for the request.
   * @param data.userSessionId The user session ID.
   * @param data.localeId
   * @param data.userToken
   * @returns number OK
   * @throws ApiError
   */
  public static getCustomApiConfigurationPublicShoppingCartPositionsCount(
    data: GetCustomApiConfigurationPublicShoppingCartPositionsCountData = {},
  ): CancelablePromise<GetCustomApiConfigurationPublicShoppingCartPositionsCountResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/custom/api/Configuration/public/shoppingCart/positions/count",
      query: {
        userSessionId: data.userSessionId,
        localeID: data.localeId,
        userToken: data.userToken,
      },
      errors: {
        500: "Internal Server Error",
      },
    });
  }

  /**
   * This endpoint adds a product from the request body to the shopping cart that belongs to the user session ID.
   * @param data The data for the request.
   * @param data.requestBody
   * @returns QuoteResponse OK
   * @throws ApiError
   */
  public static postCustomApiConfigurationPublicShoppingCartProducts(
    data: PostCustomApiConfigurationPublicShoppingCartProductsData = {},
  ): CancelablePromise<PostCustomApiConfigurationPublicShoppingCartProductsResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/custom/api/Configuration/public/shoppingCart/products",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.lineItemId
   * @param data.requestBody
   * @returns unknown OK
   * @throws ApiError
   */
  public static putCustomApiConfigurationPublicShoppingCartConfigurationsByLineItemId(
    data: PutCustomApiConfigurationPublicShoppingCartConfigurationsByLineItemIdData,
  ): CancelablePromise<PutCustomApiConfigurationPublicShoppingCartConfigurationsByLineItemIdResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/custom/api/Configuration/public/shoppingCart/configurations/{lineItemId}",
      path: {
        lineItemId: data.lineItemId,
      },
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        400: "Bad Request",
        500: "Internal Server Error",
      },
    });
  }

  /**
   * Update shopping cart extended data.
   * @param data The data for the request.
   * @param data.quoteId
   * @param data.requestBody
   * @returns unknown OK
   * @throws ApiError
   */
  public static putCustomApiConfigurationPublicShoppingCartByQuoteIdExtendedData(
    data: PutCustomApiConfigurationPublicShoppingCartByQuoteIdExtendedDataData,
  ): CancelablePromise<PutCustomApiConfigurationPublicShoppingCartByQuoteIdExtendedDataResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/custom/api/Configuration/public/shoppingCart/{quoteId}/extendedData",
      path: {
        quoteId: data.quoteId,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * Get shopping cart extended data.
   * @param data The data for the request.
   * @param data.quoteId
   * @param data.userSessionId
   * @param data.userToken
   * @returns QuoteExtendedData OK
   * @throws ApiError
   */
  public static getCustomApiConfigurationPublicShoppingCartByQuoteIdExtendedData(
    data: GetCustomApiConfigurationPublicShoppingCartByQuoteIdExtendedDataData,
  ): CancelablePromise<GetCustomApiConfigurationPublicShoppingCartByQuoteIdExtendedDataResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/custom/api/Configuration/public/shoppingCart/{quoteId}/extendedData",
      path: {
        quoteId: data.quoteId,
      },
      query: {
        userSessionId: data.userSessionId,
        userToken: data.userToken,
      },
    });
  }

  /**
   * Update line item cart extended data.
   * @param data The data for the request.
   * @param data.lineItemId
   * @param data.requestBody
   * @returns unknown OK
   * @throws ApiError
   */
  public static putCustomApiConfigurationPublicShoppingCartLineItemByLineItemIdExtendedData(
    data: PutCustomApiConfigurationPublicShoppingCartLineItemByLineItemIdExtendedDataData,
  ): CancelablePromise<PutCustomApiConfigurationPublicShoppingCartLineItemByLineItemIdExtendedDataResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/custom/api/Configuration/public/shoppingCart/lineItem/{lineItemId}/extendedData",
      path: {
        lineItemId: data.lineItemId,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * Get line item extended data.
   * @param data The data for the request.
   * @param data.lineItemId
   * @param data.userSessionId
   * @param data.userToken
   * @returns LineItemExtendedData OK
   * @throws ApiError
   */
  public static getCustomApiConfigurationPublicShoppingCartLineItemByLineItemIdExtendedData(
    data: GetCustomApiConfigurationPublicShoppingCartLineItemByLineItemIdExtendedDataData,
  ): CancelablePromise<GetCustomApiConfigurationPublicShoppingCartLineItemByLineItemIdExtendedDataResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/custom/api/Configuration/public/shoppingCart/lineItem/{lineItemId}/extendedData",
      path: {
        lineItemId: data.lineItemId,
      },
      query: {
        userSessionId: data.userSessionId,
        userToken: data.userToken,
      },
    });
  }

  /**
   * Generate a shopping cart Excel report.
   * @param data The data for the request.
   * @param data.quoteId Shopping cart quote guid
   * @param data.requestBody Contains sessionId and excel header values
   * @returns unknown OK
   * @throws ApiError
   */
  public static postCustomApiConfigurationPublicShoppingCartByQuoteIdExcel(
    data: PostCustomApiConfigurationPublicShoppingCartByQuoteIdExcelData,
  ): CancelablePromise<PostCustomApiConfigurationPublicShoppingCartByQuoteIdExcelResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/custom/api/Configuration/public/shoppingCart/{quoteId}/Excel",
      path: {
        quoteId: data.quoteId,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * Sends a quote request e-mail from the customer.
   * @param data The data for the request.
   * @param data.requestBody
   * @returns unknown OK
   * @throws ApiError
   */
  public static postCustomApiConfigurationPublicShoppingCartQuoteRequestMail(
    data: PostCustomApiConfigurationPublicShoppingCartQuoteRequestMailData = {},
  ): CancelablePromise<PostCustomApiConfigurationPublicShoppingCartQuoteRequestMailResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/custom/api/Configuration/public/shoppingCart/quoteRequest/mail",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * Hello world for testing and healh checks
   * @returns unknown OK
   * @throws ApiError
   */
  public static getCustomApiConfigurationPublicHelloWorld(): CancelablePromise<GetCustomApiConfigurationPublicHelloWorldResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/custom/api/Configuration/public/helloWorld",
    });
  }
}
